// Sprint 4 Phase B — finale Inhaltstexte (32 Texte, 1:1 mit backend/fokustyp_data.py).
// Sprachregel: KEIN "Du bist [Fokustyp]" — IMMER "Bei dir dominiert der [X]-Anteil" oder
// "Dein dominierender Anteil ist [X]".

export const NAME_PHRASE_BY_FOKUSTYP = {
  eule: "Dein dominierender Anteil ist Eule",
  biene: "Dein dominierender Anteil ist Biene",
  katze: "Dein dominierender Anteil ist Katze",
  hund: "Dein dominierender Anteil ist Hund",
};

// Charakter — Sprint 4 Phase B (1.1–1.4).
export const CHARAKTERISIERUNG_BY_FOKUSTYP = {
  eule:
    "Bei dir dominiert der Eule-Anteil. Du willst verstehen, warum etwas sinnvoll ist — bevor du mitmachst. Wenn du keinen Sinn siehst, blockst du ab, und das ist nicht Sturheit, sondern dein Anspruch an dich selbst und andere. Du hinterfragst, vergleichst, willst Substanz statt Behauptung. In Gesprächen spürst du, wenn jemand um den heißen Brei redet — und sagst es auch. Das kann wirken wie Widerstand, ist aber oft der ehrlichste Beitrag zur Sache. Deine Stärke liegt darin, Dinge auf den Punkt zu bringen und Qualität zu sichern. Was dich herausfordert: Nicht jede Frage braucht sofort eine Antwort — manches entfaltet sich im Tun. Vertrauen in den Prozess fällt dir schwer, wenn du nicht den Beweis im Voraus hast.",
  biene:
    "Bei dir dominiert der Biene-Anteil. Du willst wissen, wie etwas geht — Schritt für Schritt, mit klarem Plan. Unklare Aufgaben machen dich unruhig, und du reagierst darauf, indem du nachhakst, strukturierst und nichts dem Zufall überlässt. Dieser Anteil sorgt im Team dafür, dass der Überblick bleibt, wenn andere schon im Detail stecken oder längst aufgegeben haben. Deine Stärke liegt darin, Komplexes zerlegbar zu machen und dranzubleiben, bis etwas wirklich fertig ist. Was dich herausfordert: Nicht jeder Plan ist der einzige Plan. Manchmal ist „gut genug“ der bessere nächste Schritt als „perfekt, aber erst nächste Woche“.",
  katze:
    "Bei dir dominiert der Katze-Anteil. Du willst spüren, ob etwas zu DIR passt — bevor du Energie reinsteckst. Wenn du keinen inneren Anker findest, steigst du aus, und das ist nicht Bequemlichkeit, sondern dein ehrliches Signal an dich selbst. Du gehst Dinge nur an, wenn sie sich für dich richtig anfühlen — und genau deshalb bist du in den Dingen, die dich wirklich reizen, ausdauernd und gründlich. Deine Stärke liegt darin, dich nicht zu verbiegen und trotzdem dran zu bleiben, wenn es dich packt. Was dich herausfordert: Nicht jede Aufgabe wird sich anfühlen wie „ja, genau das“. Manchmal ist die zweite Reihe trotzdem deine — du musst nur selbst entscheiden, was du daraus machst.",
  hund:
    "Bei dir dominiert der Hund-Anteil. Du willst wissen, wer mit dir spricht und wie das Miteinander gemeint ist — bevor du dich auf eine Sache einlässt. Wenn du dich nicht gesehen fühlst, ziehst du dich zurück oder passt dich an, und das ist nicht Schwäche, sondern dein Sensor für Verlässlichkeit. Dieser Anteil nimmt Stimmungen im Raum früh wahr, spürt aufkommende Konflikte und geht auf andere zu, wenn die schon im Streit sind. Deine Stärke liegt darin, andere mitzunehmen und Verbindungen zu halten, auch wenn es dich selbst Kraft kostet. Was dich herausfordert: Nicht jeder braucht deine Bestätigung, und nicht jede Stille ist Ablehnung. Manchmal wartet der andere nur auf den ersten Schritt — und den darfst auch du gehen.",
};

// Legacy: diagonale Konfliktpotenzial-Paare (1× pro Fokustyp).
// In Sprint 4 Phase B ersetzt durch KONFLIKTPOTENZIAL_PAARE_BY_FOKUSTYP (3× pro FT).
// Wir behalten dieses Mapping als Fallback / für Pages, die noch nicht migriert sind.
export const KONFLIKTPOTENZIAL_BY_FOKUSTYP = {
  eule: { partner: "hund", intro: "", verstehen: "", beobachten: "" },
  biene: { partner: "katze", intro: "", verstehen: "", beobachten: "" },
  katze: { partner: "biene", intro: "", verstehen: "", beobachten: "" },
  hund: { partner: "eule", intro: "", verstehen: "", beobachten: "" },
};

// Sprint 4 Phase B — 12 Konfliktpotenzial-Paare (Sektion 2.1–2.12).
// Mapping: [User-FT][Ziel-FT] → Paragraph-Text.
export const KONFLIKTPOTENZIAL_PAARE_BY_FOKUSTYP = {
  eule: {
    biene:
      "Du gibst deinem Gegenüber die Begründung, fundiert und substanziell. Der Biene-Anteil will den Plan. Wenn du Sinn und Schritte trennst — erst „warum“, dann „wie“ — bekommt dein Gegenüber beides und kann dranbleiben.",
    hund:
      "Du willst direkt in die Sache. Der Hund-Anteil braucht einen Moment, um sich mit dir verbunden zu fühlen. Wenn du einen Satz Beziehungs-Vorlauf voranstellst, bevor du auf den Punkt kommst, hört dein Gegenüber dir zu — und deine Argumente kommen an.",
    katze:
      "Du begründest von außen („weil es sinnvoll ist“, „weil alle es machen“). Der Katze-Anteil steigt aus. Wenn du aus dir selbst heraus begründest („weil es DIR dann besser geht“, „weil du es dann willst“), hast du dein Gegenüber.",
  },
  biene: {
    eule:
      "Du gibst deinem Gegenüber einen Plan, Schritt für Schritt, sauber strukturiert. Der Eule-Anteil nickt — und fragt dann: „Aber warum genau das?“ Das ist nicht Kritik an deiner Arbeit. Der Sinn ist notwendig, bevor der Weg akzeptiert wird. Wenn du die Begründung pro Schritt mitgibst („Erstens X, weil Y. Zweitens Z, weil W.“), hast du dein Gegenüber an Bord.",
    hund:
      "Du erklärst deinem Gegenüber den Plan — und der Hund-Anteil schaut dich an, als wäre die Erklärung egal. Was fehlt, ist kein Schritt-für-Schritt, sondern ein Gefühl dafür, was das für euch beide bedeutet. Wenn du ergänzt, was die Sache mit der Beziehung zu tun hat („Wenn wir das zusammen machen, ist uns beiden geholfen.“), fühlt dein Gegenüber sich mitgemeint.",
    katze:
      "Du gibst deinem Gegenüber Ziel und Plan — und der Katze-Anteil zuckt mit den Schultern. Was fehlt, ist nicht die Struktur, sondern ein Gefühl dafür, was daran reizt. Wenn du Ziel plus ein bis zwei erste Schritte anbietest („Wir machen X, dann Y. Reizt dich das?“), lässt dein Gegenüber sich eher drauf ein.",
  },
  hund: {
    biene:
      "Du gibst deinem Gegenüber das Gefühl, dass es gemeint ist. Der Biene-Anteil braucht trotzdem den nächsten Schritt. Wenn du den Beziehungs-Anker mit einer konkreten Frage verbindest („Mir ist wichtig, dass wir das zusammen hinkriegen — was wäre dein nächster Schritt?“), hast du beides geliefert.",
    eule:
      "Du baust einen warmen Flexpfad auf. Der Eule-Anteil filtert das aus. Was gebraucht wird, ist direkt in die Sache, kurz, ohne Schnörkel. Wenn du sagst: „Hier ist, was ich sehe. Hier ist, was ich brauche. Passt das?“ — knapp und auf den Punkt — bekommst du dafür Respekt.",
    katze:
      "Du redest zu lange und zu warm. Der Katze-Anteil hört nur noch „Blabla“. Wenn du kurz, warm und direkt wirst („Hör zu, ich brauch grad [X]. Kannst du [Y]?“), bist du dran.",
  },
  katze: {
    biene:
      "Du sagst, was dich reizt. Der Biene-Anteil will den Plan, nicht deine Lust. Wenn du deinen inneren Anker mit einer Bitte um den ersten Schritt verbindest („Mir ist wichtig, dass [X] — wie würden wir anfangen?“), hast du dein Gegenüber.",
    eule:
      "Du sagst, was dich reizt. Der Eule-Anteil will wissen, warum es sinnvoll ist. Wenn du nicht „weil es alle machen“ sagst, sondern „weil ich das will“ — und das ehrlich meinst —, lässt dein Gegenüber sich auf dich ein.",
    hund:
      "Du sagst direkt, was du brauchst. Der Hund-Anteil braucht die Beziehungs-Bestätigung dazu. Wenn du direkt, aber kurz warm wirst („Hör zu, ich brauch grad [X]. Mir ist wichtig, dass du [Y] machst.“), bist du an der Seite deines Gegenübers.",
  },
};

// Sprint 4 Phase B — Flexpfade (4.1–4.4).
// Mapping: [User-FT].adressat = diagonal partner; .saetze = Phase-B-Sätze für ZIEL=adressat;
// .intro = Phase-B-Empathie-Lead; .hinweis = Pro-Solo-Upsell.
export const DREI_SATZ_BRUECKE_BY_FOKUSTYP = {
  // Eule-User adressiert Hund (diagonal) → Phase B 4.4 (Hund).
  eule: {
    adressat: "hund",
    heading: "So erreichst du einen Hund",
    intro:
      "Du kennst das Gefühl, wenn du mit einem Hund-Anteil sprichst und dein Gegenüber sich nicht gehört fühlt. Hier sind 3 Sätze, die es ändern:",
    saetze: [
      "Mir ist wichtig, dass wir da auf einer Wellenlänge sind — wie siehst du das?",
      "Ich will nicht nur meine Sache durchziehen, sondern dass wir das zusammen tragen.",
      "Was brauchst du von mir, damit das für dich okay ist?",
    ],
    hinweis:
      "Mit Pro Solo bekommst du 4 Flexpfade — einen für jeden Fokustyp.",
  },
  // Biene-User adressiert Katze (diagonal) → Phase B 4.3 (Katze).
  biene: {
    adressat: "katze",
    heading: "So erreichst du eine Katze",
    intro:
      "Du kennst das Gefühl, wenn du mit einem Katze-Anteil sprichst und dein Gegenüber keinen Antrieb spürt. Hier sind 3 Sätze, die es ändern:",
    saetze: [
      "Ich will ehrlich sein: das reizt mich, weil [intrinsischer Grund].",
      "Wenn ich das machen würde, wäre das für mich [persönlicher Nutzen].",
      "Wenn DU da keinen Bock drauf hast, lass es — ich frag nur, weil mich das selbst interessiert.",
    ],
    hinweis:
      "Mit Pro Solo bekommst du 4 Flexpfade — einen für jeden Fokustyp.",
  },
  // Katze-User adressiert Biene (diagonal) → Phase B 4.2 (Biene).
  katze: {
    adressat: "biene",
    heading: "So erreichst du eine Biene",
    intro:
      "Du kennst das Gefühl, wenn du mit einem Biene-Anteil sprichst und dein Gegenüber nur den Plan sucht. Hier sind 3 Sätze, die es ändern:",
    saetze: [
      "Ich hab einen Vorschlag — wir machen erst [X], dann [Y]. So bleibt es überschaubar.",
      "Was ich an dem Plan mag: jeder Schritt ist klar, keiner überfordert dich.",
      "Passt das so für dich — oder würdest du etwas anders reihen?",
    ],
    hinweis:
      "Mit Pro Solo bekommst du 4 Flexpfade — einen für jeden Fokustyp.",
  },
  // Hund-User adressiert Eule (diagonal) → Phase B 4.1 (Eule).
  hund: {
    adressat: "eule",
    heading: "So erreichst du eine Eule",
    intro:
      "Du kennst das Gefühl, wenn du mit einem Eule-Anteil sprichst und dein Gegenüber nur das Warum hört. Hier sind 3 Sätze, die es ändern:",
    saetze: [
      "Ich hab mir das eine Weile durch den Kopf gehen lassen — und es ergibt für mich Sinn, weil [Grund].",
      "Ich will dir zeigen, warum ich glaube, dass das der richtige Weg ist.",
      "Was meinst du: passt das aus deiner Sicht?",
    ],
    hinweis:
      "Mit Pro Solo bekommst du 4 Flexpfade — einen für jeden Fokustyp.",
  },
};

// V1.G (Launch-Consolidation, 30.08.2026) — Konfliktpaar-Severity.
// Diagonal-Paare in der 4er-Matrix (Katze OL / Eule OR / Hund UL / Biene UR):
//   - 😸 Katze ↔ 🐝 Biene  (OL ↔ UR)
//   - 🦉 Eule  ↔ 🐶 Hund   (OR ↔ UL)
// werden als "kritisch" markiert, alle anderen als "normal".
const KONFLIKT_DIAGONAL_PAARE = [
  ["katze", "biene"],
  ["eule", "hund"],
];

export function getKonfliktSeverity(userSlug, zielSlug) {
  if (!userSlug || !zielSlug || userSlug === zielSlug) return "normal";
  const found = KONFLIKT_DIAGONAL_PAARE.some(
    (pair) => pair.includes(userSlug) && pair.includes(zielSlug),
  );
  return found ? "kritisch" : "normal";
}

